// Las políticas en su modal: días enteros, el tope del multiplicador como factor (×2.5 = 25000 bps)
// y el bloque Pagos.
import type { RetailCommission } from '@fiado/type-kit';
import { CommissionBillingPeriodEnum } from '@fiado/type-kit/bin/retailCommission/enums/CommissionBillingPeriodEnum';
import { CommissionWindowEnum } from '@fiado/type-kit/bin/retailCommission/enums/CommissionWindowEnum';

export interface PoliciesFormValues {
    cancelacionDias: string;
    devolucionDias: string;
    npiM30Dias: string;
    cap: string;
    ventana: CommissionWindowEnum;
    walletDeposits: boolean;
    chainBillingPeriod: CommissionBillingPeriodEnum;
}

export type PoliciesFormErrors = Partial<Record<keyof PoliciesFormValues, string>>;

const DAY_FIELDS = ['cancelacionDias', 'devolucionDias', 'npiM30Dias'] as const;

export function policiesToForm(
    policies: RetailCommission.CommissionPolicies | undefined,
): PoliciesFormValues {
    const clawback = policies?.clawback ?? null;
    const commissions = policies?.commissions ?? null;
    // Sin política de pagos guardada, el motor deposita a la wallet y cobra cada semana.
    const payouts = policies?.payouts ?? null;
    return {
        cancelacionDias: clawback ? String(clawback.cancelacionDias) : '',
        devolucionDias: clawback ? String(clawback.devolucionDias) : '',
        npiM30Dias: clawback ? String(clawback.npiM30Dias) : '',
        cap: commissions ? String(commissions.multiplicadorMaxBps / 10_000) : '',
        ventana: commissions?.ventanaDefault ?? CommissionWindowEnum.SEMANA_OPERATIVA,
        walletDeposits: payouts?.walletDeposits ?? true,
        chainBillingPeriod: payouts?.chainBillingPeriod ?? CommissionBillingPeriodEnum.WEEKLY,
    };
}

export function validatePolicies(v: PoliciesFormValues): PoliciesFormErrors {
    const errors: PoliciesFormErrors = {};
    for (const key of DAY_FIELDS) {
        const days = Number(v[key]);
        if (v[key].trim() === '' || !Number.isInteger(days) || days < 0)
            errors[key] = 'Días enteros desde 0.';
    }
    const cap = Number(v.cap);
    if (v.cap.trim() === '' || !Number.isFinite(cap) || cap < 1)
        errors.cap = 'El tope es ×1 o más.';
    return errors;
}

export function formToPolicies(v: PoliciesFormValues): RetailCommission.UpdatePoliciesRequest {
    return {
        clawback: {
            cancelacionDias: Number(v.cancelacionDias),
            devolucionDias: Number(v.devolucionDias),
            npiM30Dias: Number(v.npiM30Dias),
        },
        commissions: {
            multiplicadorMaxBps: Math.round(Number(v.cap) * 10_000),
            ventanaDefault: v.ventana,
        },
        payouts: {
            walletDeposits: v.walletDeposits,
            chainBillingPeriod: v.chainBillingPeriod,
        },
    };
}
